import React, {Component} from 'react';
import FavouriteAPI from "../classes/FavouriteAPI";
import {Trans} from "react-i18next";

class Favourite extends Component {
  constructor(props) {
    super(props);
    this.state = {flagged:false};
    this.favouriteAPI = new FavouriteAPI();
    this.favouriteAPI.isFavourite(this.props.nid).then((isFavourite) => this.setState({flagged: isFavourite}));
    this.flagIt = this.flagIt.bind(this);
  }

  componentDidMount() {
    this.favouriteAPI.isFavourite(this.props.nid).then((isFavourite) => this.setState({flagged: isFavourite}));
  }

  flagIt() {
    if (this.favouriteAPI.favourite(this.props.nid)) {
      this.setState({flagged: !this.state.flagged})
    }
  }

  render() {
    let flag_class = (this.state.flagged ? 'action-unflag' : 'action-flag');
    return (
      <button onClick={this.flagIt} className={"favourite favourite--small button flag-favourites js-flag-favourites-14 "+flag_class}>
        <span href={drupalSettings.path.baseUrl + "flag/unflag/favourites/14?destination&amp;token=Ac14_7JGMK2FTIQB8RXgCEl4N2KSx7rkN1v-2i2mWzY"}
              className="use-ajax"
              rel="nofollow">
          <span className="favourite__title button__text">
            <Trans i18nKey="favourite.label_add_favourite">Add to favourites</Trans>
          </span>
          <span className="favourite__delete button__text">
            <Trans i18nKey="favourite.label_remove_favourite">Remove from favourites</Trans>
          </span>
        </span>
      </button>
    );
  }
}

export default Favourite;
